const slideEstudaQueMuda = () => {

    const moduloId = `#estuda-que-muda`;

    let slideControllers = () => {

        $(`${moduloId} .slide-controller`).on(`click`, function() {

            let target = $(this).data(`target`);

            desactiveNavigationArrows(target);

            removeClassActive();
            addClassActive(target);
            srollTopInMobile();
        });
    }

    let removeClassActive = () => {

        $(`
            ${moduloId} .slide-controller,
            ${moduloId} .slide-conteudo,
            ${moduloId} .slide-bullets span

        `).removeClass(`active`);
    }

    let addClassActive = (dataTarget) => {

        $(`
            ${moduloId} .slide-controller[data-target=${dataTarget}],
            ${moduloId} .slide-conteudo[data-slide=${dataTarget}],
            ${moduloId} .slide-bullets span[data-bullet=${dataTarget}]

        `).addClass(`active`);
    }

    let desactiveNavigationArrows = (target) => {

        $(`${moduloId} .slide-navigation > span`).removeClass(`desactive`);

        if (target === 1) {
            $(`${moduloId} .slide-navigation .arrow-left`).addClass(`desactive`);

        } else if(target === 3) {
            $(`${moduloId} .slide-navigation .arrow-right`).addClass(`desactive`);
        }
    }

    let slideNavigation = () => {

        $(`${moduloId} .slide-navigation span`).on(`click`, function() {

            if (! $(this).hasClass(`desactive`) ) {

                $(`${moduloId} .slide-navigation span`).removeClass('desactive');

                let target = $(`${moduloId} .slide-controller.active`).data(`target`);

                if ( $(this).hasClass(`arrow-left`) ) {
                    desactiveNavigationArrows(target -= 1);

                } else {
                    desactiveNavigationArrows(target += 1);
                }

                removeClassActive();
                addClassActive(target);
                srollTopInMobile();
            }
        });
    }

    let srollTopInMobile = () => {

        if (screen.width <= 480) {
            $('html, body').animate({
                scrollTop: $(`${moduloId}`).offset().top - 86
            }, 0);
        }
    };

    let slideModalVideos = () => {

        $(`${moduloId} .slide-conteudo`).on('show.bs.modal', function () {

            let src = $(this).find(`iframe`).data(`src`);
            $(this).find(`iframe`).attr(`src`, src);
        });

        $(`${moduloId} .slide-conteudo`).on('hidden.bs.modal', function () {

            $(this).find(`iframe`).removeAttr(`src`);
        });
    }

    let init = () => {
        slideControllers();
        slideNavigation();
        slideModalVideos();
    }

    return {
       init: init
    };

};
$(document).ready(slideEstudaQueMuda().init);